(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("locator", [], factory);
	else if(typeof exports === 'object')
		exports["locator"] = factory();
	else
		root["locator"] = factory();
})(this, () => {
return 